import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deletePricingProfileDateRange } from '../../../../actions/sales/PricingProfileDateRange';

const DeletePricingProfileDateRangeButton = ({
  dispatchDeletePricingProfileDateRange,
  pricingProfileDateRangeId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () =>
    dispatchDeletePricingProfileDateRange({ pricingProfileDateRangeId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  const body =
    '¿Está seguro que desea eliminar este rango de fechas para perfil de precio? , se va a eliminar toda la información relacionada a este rango de fechas para perfil de precio.';

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
        body={body}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

DeletePricingProfileDateRangeButton.propTypes = {
  dispatchDeletePricingProfileDateRange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  pricingProfileDateRangeId: PropTypes.number.isRequired,
};

DeletePricingProfileDateRangeButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeletePricingProfileDateRange: deletePricingProfileDateRange,
};

export default connect(
  null,
  mapDispatchToProps,
)(DeletePricingProfileDateRangeButton);
